import { useLocation, useNavigate } from 'react-router-dom';

import { createPeopleGroup, readPeopleGroupPrompts } from '@api/people_groups';
import { Breadcrumbs, Layout } from '@utilities';

import Builder from '../../components/Builder';
import Page from '../../layouts/Page';

const CreatePeopleGroup = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return (
    <Page>
      <Layout.Column>
        <Breadcrumbs />
        <Builder
          create={createPeopleGroup}
          documentId="people-group"
          onSubmit={() => navigate('/dashboard/workspace/people-groups')}
          read={(serviceName) => readPeopleGroupPrompts({ search, serviceName, transform: false })}
          type="People Group"
        />
      </Layout.Column>
    </Page>
  );
};

export default CreatePeopleGroup;
